import useApi from "./api";

// Transfer-specific API methods
export const useTransferApi = () => {
  const api = useApi(false);

  // Get transfer status by ID (for step-up auth polling)
  const getTransferStatus = async (transferId) => {
    try {
      const response = await api.get(`transfer/history/${transferId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching transfer status:", error);
      throw error;
    }
  };

  // Cancel a pending Request for Pay the current user created (the requester).
  // RfP rows use a dedicated endpoint — NOT the DELETE /transfer/outgoing route
  // used for normal sends — because the requester sits on to_account and the
  // cancel is authorized + transitioned differently on the backend.
  const cancelRequest = async (transferId) => {
    const response = await api.post(`request/${transferId}/cancel`);
    return response.data;
  };

  return {
    getTransferStatus,
    cancelRequest,
  };
};